import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './firebase';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorReporting } from './utils/errorReporting';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';

installGlobalErrorReporting();

// AuthProvider wordt al binnenin App.js aangemaakt (rond AppRoutes, binnen de
// Router) — hier nog eens apart wrappen zorgde voor een TWEEDE, volledig
// ongebruikte Firebase Auth-listener (en bij een ingelogde gebruiker ook een
// tweede live Firestore-listener op hetzelfde document) bij elke paginalading,
// voor niets: AppRoutes leest toch enkel de binnenste Provider.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
                console.log('Service Worker geregistreerd:', registration);
            })
            .catch(error => {
                console.log('Service Worker registratie mislukt:', error);
            });
    });
}